import { connect } from 'react-redux'
import {
    getMatomoConfiguration,
    isMatomoEnabled
} from '../../../redux/app/selectors'
import Matomo from './Matomo.jsx'

const mapStateToProps = state => ({
    configuration: getMatomoConfiguration(state),
    isEnabled: isMatomoEnabled(state),
})

export const MatomoContainer = connect(
    mapStateToProps,
)(Matomo)
